module.exports = __webpack_public_path__ + "static/media/pitch.504d0407.png";